import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";

import { URL, admin, getAuthorizationHeader, verificarRol, gestionLegajos } from "../../../constans/constants";


import MensajeFlash from "../../mensajeFlash/MensajeFlash";
import PantallaCarga from "../../mensajeFlash/PantallaCarga";
import { logout } from "../../login/SesionService";
import BreadCrumComponent from "../../componentes/BreadCrumComponent";
import TablaItemsConfiguracion from "../../componentes/tablas/TablaItemsConfiguracion";
/* import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js"; */

// TODO: crear/usar modal detalle legajo (copiar el de usuario y adaptar campos)
/* import ModalDetalleLegajo from "../componentes/modales/ModalDetalleLegajo.js"; */

// TODO: IMPORTAR tu service real
// Ejemplo: import { getLegajos, desactivarLegajo } from "./LegajoService";
import { getLegajos, obtenerCabeceraLegajo,importarLegajosDesdeMiembros } from "./LegajoService";

export const obtenerIdEmpresa = () => {
  const cookies = new Cookies();
  return cookies.get("empresa");
};

export const esSesionAdmin = () => {
  const cookies = new Cookies();
  return cookies.get("admin") == "true";
};

class Legajos extends React.Component {
  constructor(props) {
    super(props);

    const { location } = this.props;
    const estado = location && location.state ? location.state : {};

    this.state = {
      legajoSeleccionado: null,

      dialogIsOpenVerDatos: false,
      openEliminar: false,

      openPantallaCarga: false,

      mensajeFlash: estado.mensajeFlash || "",
      mostrarMensajeFlash: estado.mostrarMensajeFlash || false,
      mensajeFlashSeverity: estado.mensajeFlashSeverity || "neutral",
    };

    this.modalDetalleRef = React.createRef();
    this.tablaRef = React.createRef();
    this.modalEliminarRef = React.createRef();
  }

  handleVerLegajo = (datos) => {
    this.props.history.push({
      pathname: `/administracion/legajo/ver/${datos.legajoId}`,
      state: { legajo: datos },
    });
  };

  handleClickOpenEliminar = (legajo = null) => {
    this.setState({
      openEliminar: true,
      legajoSeleccionado: legajo,
    });
  };

  handleCloseEliminar = () => {
    this.setState({ openEliminar: false });
  };

  handleNewLegajo = () => {
    this.props.history.push("/administracion/legajos/add");
  };

  handleEditarLegajo = (datos) => {
    console.log(datos)
    this.props.history.push({
      pathname: "/administracion/legajo/editar/"+datos.legajoId,
      state: { legajo: datos },
    });
  };

  handleDialogImportarLegajos = () => {
    this.props.history.push(
      !esSesionAdmin()
        ? "/administracion/legajos/importar"
        : "/admin/legajos/importar"
    );
  };

  descargarXls = () => {
    // Ajustá endpoint según tu backend
    let empresa = esSesionAdmin() ? -200 : obtenerIdEmpresa();
    window.location.href = URL + "legajo/xls/" + empresa;
  };

  actualizarDatosTabla = () => {
    if (this.tablaRef) this.tablaRef.fetchData();
  };

fetchLegajos = (page, pageSize, search) => {
  return this.props.getLegajos(page, pageSize, search).then(() => {
    const legajosData = this.props.legajosData || {};
    console.log(legajosData)
    return {
      items: Array.isArray(legajosData.legajos) ? legajosData.legajos : [],
      totalCount: typeof legajosData.totalCount === "number" ? legajosData.totalCount : 0,
    };
  });
};


  // Si tu backend “elimina” o “desactiva” similar a usuarios, ajustá el endpoint
  handleDisableLegajo = () => {
    this.modalEliminarRef.cerrarModalConAnimacion();
    this.setState({ openPantallaCarga: true });

    const empresa = obtenerIdEmpresa() != null ? obtenerIdEmpresa() : 0;
    const legajo = this.state.legajoSeleccionado;

    axios
      .delete(
        URL + "legajo/" + legajo.id + "/empresa/" + empresa,
        getAuthorizationHeader()
      )
      .then(
        (response) => {
          this.setState({
            openPantallaCarga: false,
            mostrarMensajeFlash: true,
            mensajeFlash: response.data.mensaje,
            mensajeFlashSeverity: response.data.error ? "error" : "exito",
          });
          this.actualizarDatosTabla();
        },
        (error) => {
          this.setState({ openPantallaCarga: false });
          if (error?.response?.status === 401) logout();

          this.setState({
            mostrarMensajeFlash: true,
            mensajeFlash: "No se pudo eliminar el legajo.",
            mensajeFlashSeverity: "error",
          });
          return error;
        }
      );
  };

 handleImportarDesdeUsuarios = () => {
  this.setState({ openPantallaCarga: true });

  importarLegajosDesdeMiembros()
    .then((resp) => {
      const data = resp.data;

      this.setState({
        openPantallaCarga: false,
        mostrarMensajeFlash: true,
        mensajeFlash:
          data?.mensaje ||
          `Importación finalizada. Creados: ${data?.creados ?? 0}, Actualizados: ${data?.actualizados ?? 0}, Omitidos: ${data?.omitidos ?? 0}`,
        mensajeFlashSeverity: "exito",
      });

      this.actualizarDatosTabla();
    })
    .catch((error) => {
      this.setState({ openPantallaCarga: false });

      if (error?.response?.status === 401) logout();

      this.setState({
        mostrarMensajeFlash: true,
        mensajeFlash:
          error?.response?.data?.mensaje || "No se pudo importar legajos desde miembros.",
        mensajeFlashSeverity: "error",
      });
    });
};

  renderFilas = (filas) => {
    return filas.map((f) => (
      <tr key={f.id}>
        <td>{f.cedula}</td>
        <td>{f.nombreApellido}</td>
        <td>{f.username}</td>
        <td>{f.correo}</td>
        <td>
          <div className="table-actions">
            <button
              className="table-icon"
              onClick={() => this.handleVerLegajo(f)}
            >
              <span className="material-symbols-outlined">visibility</span>
            </button>

            <button className="table-icon" onClick={() => this.handleEditarLegajo(f)}>
              <span className="material-symbols-outlined">edit</span>
            </button>

            <button
              className="table-icon open-dialog"
              onClick={() => this.handleClickOpenEliminar(f)}
            >
              <span className="material-symbols-outlined">delete</span>
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  render() {
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              {!admin() && (
                <BreadCrumComponent
                  backUrl={"/bandeja/pendientes"}
                  breadcrumbs={[
                    { label: "Menu principal", path: "/bandeja/pendientes" },
                  ]}
                />
              )}

              <nav className="nav-area">
                {admin() ? (
                  <>
                    <NavLink to="/admin/usuarios" className="nav-link">
                      <span className="material-symbols-outlined">account_circle</span>
                      Usuarios
                    </NavLink>
                    <NavLink to="/admin/empresas" className="nav-link">
                      <span className="material-symbols-outlined">account_balance</span>
                      Empresas
                    </NavLink>
                    <NavLink to="/admin/proveedores-firma" className="nav-link">
                      <span className="material-symbols-outlined">check_box</span>
                      Proveedores de Firma
                    </NavLink>
                    <NavLink to="/notificacion/configuracion-correo" className="nav-link">
                      <span className="material-symbols-outlined">mail</span>
                      Servidor de Correo
                    </NavLink>
                    <NavLink to="/admin/legajos" className="nav-link">
                      <span className="material-symbols-outlined">assignment_ind</span>
                      Legajos
                    </NavLink>
                  </>
                ) : (
                  <>
                    <NavLink to="/administracion/usuarios" className="nav-link">
                      <span className="material-symbols-outlined">account_circle</span>
                      Usuarios
                    </NavLink>
                    <NavLink to="/administracion/grupos" className="nav-link">
                      <span className="material-symbols-outlined">supervised_user_circle</span>
                      Grupos de usuarios
                    </NavLink>
                    {verificarRol(JSON.parse(localStorage.getItem("roles")), [gestionLegajos]) && <NavLink to="/administracion/legajos" className="nav-link">
                      <span className="material-symbols-outlined">assignment_ind</span>
                      Legajos
                    </NavLink>}
                    {verificarRol(JSON.parse(localStorage.getItem("roles")), [gestionLegajos]) && <NavLink to="/administracion/vacaciones" className="nav-link">
                      <span className="material-symbols-outlined">beach_access</span>
                      Vacaciones
                    </NavLink>}
                  </>
                )}
              </nav>

              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title">Gestión de legajos</h1>
                  <p className="page-description">
                    Desde este menú puede gestionar los legajos de su compañía
                  </p>
                </div>

                <div className="head-actions">
{/*                   <button
                    onClick={this.descargarXls}
                    className="btn-medium btn-base-outline"
                  >
                    Descargar XLS
                  </button> */}

                  <button
                      onClick={this.handleImportarDesdeUsuarios}
                    className="btn-medium btn-primary-tonal"
                  >
                    Importar Legajos
                  </button>
{/* 
                  <button
                    onClick={this.handleNewLegajo}
                    className="btn-medium btn-primary"
                  >
                    <span className="material-symbols-outlined">person_add_alt</span>
                    Nuevo Legajo
                  </button> */}
                </div>
              </div>
            </div>
          </header>

          <div className="wrapperContent">
            <div className="page-container">
              <TablaItemsConfiguracion
                ref={(ref) => (this.tablaRef = ref)}
                titulo="Lista de legajos"
                headers={[
                  "Cedula",
                  "Nombre y apellido",
                  "Username",
                  "E-mail",
                  "Acciones",
                ]}
                fetchDatos={this.fetchLegajos}
                renderFilas={this.renderFilas}
              />
            </div>
          </div>

{/*           <ModalDetalleLegajo
            ref={(ref) => (this.modalDetalleRef = ref)}
            abierto={this.state.dialogIsOpenVerDatos}
            onClose={() => this.handleDialogVerDatos(false)}
            fetchDetalle={obtenerCabeceraLegajo}
            titulo="Datos del legajo"
            // renderContenido: lo definís dentro del modal o lo pasás como prop, igual al de usuario
          /> */}
        </div>

        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity}
        />

{/*         <ModalEliminarConDetalles
          ref={(ref) => (this.modalEliminarRef = ref)}
          isOpen={this.state.openEliminar}
          cerrarModal={this.handleCloseEliminar}
          onConfirmar={this.handleDisableLegajo}
          elemento={this.state.legajoSeleccionado}
          titulo="legajo"
          detallesAMostrar={[
            { clave: "identificador", etiqueta: "Identificador" },
            { clave: "nombreApellido", etiqueta: "Nombre" },
            { clave: "documento", etiqueta: "Documento" },
          ]}
          mensaje="Esta acción eliminará el legajo seleccionado."
          textoBotonAccion="CONFIRMAR ELIMINACIÓN"
        /> */}

        <PantallaCarga mensaje={"Procesando"} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getLegajos: (page, size, search) => dispatch(getLegajos(page, size, search)),
});

const mapStateToProps = (state) => ({
  legajosData: state.legajosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Legajos);
